import { create } from "zustand";
import { supabaseClient } from "../shared/supabase";
import { Database } from "../database.types";

type News = Database["public"]["Tables"]["news"]["Row"];

type NewsState = {
  news: News[];
  loading: boolean;
  hasMore: boolean;
  fetchNews: (reset?: boolean) => Promise<void>;
};

const PAGE_SIZE = 5;

export const useNewsStore = create<NewsState>((set, get) => ({
  news: [],
  loading: false,
  hasMore: true,

  fetchNews: async (reset = false) => {
    const { loading } = get();
    if (loading) return;

    set({ loading: true });

    try {
      const currentNews = reset ? [] : get().news;
      const from = currentNews.length;
      const to = from + PAGE_SIZE - 1;

      const { data, error } = await supabaseClient
        .from("news")
        .select("*")
        .eq("is_active", true)
        .order("display_order", { ascending: true })
        .range(from, to);

      if (error) throw error;

      const newNews = reset ? data : [...currentNews, ...data];
      const hasMore = data.length === PAGE_SIZE;

      set({
        news: newNews,
        hasMore,
        loading: false,
      });
    } catch (error) {
      console.error("Error fetching news:", error);
      set({ loading: false });
    }
  },
}));